import React from 'react';
import { Flex } from 'reflexbox';

import { INavigation } from 'packages/kakapo-ui-kit/types/Navigation';

interface IProps extends INavigation {}

export default function PlainIconNavigationBar({ renderMenuItems }: IProps) {
	return <Flex>{renderMenuItems()}</Flex>;
}
